import { RouteObject } from 'react-router-dom';
import PATH from './path';
import ProtectedPrivateRoute from '../components/template/ProtectedPrivateRoute';
import FilterTest from '../pages/TestPage/FilterTest';
import TableTestPage from 'src/pages/TestPage/TableTest';
import DetailTestPage from '../pages/TestPage/DetailTest';
import CkEditorTestPage from 'src/pages/TestPage/CkEditorTest';
import EditTestPage from '../pages/TestPage/EditTest';
import DndTestPage from '../pages/TestPage/DndTest';
import TabsTestPage from '../pages/TestPage/TabsTest';

const privateRoute: RouteObject[] = [
  {
    element: <ProtectedPrivateRoute />,
    children: [
      {
        path: PATH.FILTER_TEST,
        element: <FilterTest />,
      },
      {
        path: PATH.TABLE_TEST,
        element: <TableTestPage />,
      },
      {
        path: PATH.DETAIL_TEST,
        element: <DetailTestPage />,
      },
      {
        path: PATH.CK_EDITOR_TEST,
        element: <CkEditorTestPage />,
      },
      {
        path: PATH.FORM_TEST,
        element: <EditTestPage />,
      },
      {
        path: PATH.DND_TEST,
        element: <DndTestPage />,
      },
      {
        path: PATH.TABS_TEST,
        element: <TabsTestPage />,
      },
    ],
  },
];
export default privateRoute;
